export default {"src":"/_next/static/media/NOOM.ef0d3be0.svg","height":20,"width":90,"blurWidth":0,"blurHeight":0};